// src/policy/components/Header.tsx
import React from 'react';

interface HeaderProps {
  title: string;
}

const Header: React.FC<HeaderProps> = ({ title }) => {
  return (
    <header className="header bg-white shadow-md py-4 px-8">
      <div className="header-inner flex items-center justify-between max-w-7xl mx-auto">
        <div className="flex items-center space-x-4">
          <div className="w-10 h-10 bg-gradient-to-r from-blue-500 to-purple-600 rounded-lg flex items-center justify-center">
            <a href="https://liveclass.aiknow.ai.kr">
              <span className="text-white font-bold text-xl">AI</span>
            </a>
          </div>
          <span className="header-title text-black font-bold text-md">
            {title}
          </span>
        </div>
        <span className="header-sub text-gray-600 font-medium text-sm hidden sm:inline">
          liveclass.aiknow.ai.kr
        </span>
      </div>
    </header>
  );
};

export default Header;
